module.exports = function anonymous(it
) {
var out='<li class="entity-item table js-more-results more-records-row"> <div class="centered"> <a href="#more" class="more-records-text js-more-records link">'+(it.message)+'</a> </div></li>';return out;
}